export default __webpack_public_path__ + "static/media/back-vector.62c17ff7.svg";